import React from 'react'

import { Page, PageContent } from 'common'
import { HeaderSkeleton } from 'components/header'

import { Skeleton } from '@interco/inter-ui/components/Skeleton'

import {
  ButtonContainerSkeleton,
  SignalContainerSkeleton,
} from '../styles/UnavailableFeature.styles'

export function UnavailableFeatureSkeleton() {
  return (
    <Page>
      <HeaderSkeleton />
      <PageContent>
        <SignalContainerSkeleton>
          <Skeleton height="4rem" width="4rem" style={{ borderRadius: '50%' }} />
          <Skeleton height="1rem" width="100%" />
          <Skeleton height="1rem" width="100%" />
        </SignalContainerSkeleton>
      </PageContent>
      <ButtonContainerSkeleton>
        <Skeleton height="4rem" width="100%" />
      </ButtonContainerSkeleton>
    </Page>
  )
}
